import React, {Component} from 'react';
import {connect} from 'react-redux'
import {DropdownButton,MenuItem,Modal,Button,OverlayTrigger,Tooltip,ButtonToolbar,Row,Col,FormGroup,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { Radio, Checkbox } from 'react-icheck'
import Select from 'react-select'
import WorkdocStore from 'stores/WorkdocStore'
// import GenDocStore from 'stores/GenDocStore'
import _ from 'lodash'
import DNDRowItem from './fast/DNDRowItem'

var NotificationSystem = require('react-notification-system');
class WorkDocInvoiceMenu extends Component {

  constructor(...args){
    super(...args)
		this.state = {
			eventKey:null,
			show:false,
			isSelect:'summary',
			summary_itemlist:[],
			summary2_itemlist:[],
			work_itemlist:[],
			wage_itemlist:[],
			part_itemlist:[],
			work_status:null,
      		can_drag:false,
			darg_id:null,
			meta:{customer_name:'',vat_type:"NON_VAT"},
			docNo:null,
			isCheckAll:{summary_itemlist:false,summary2_itemlist:false,work_itemlist:false,wage_itemlist:false,part_itemlist:false},
			data:[],
			showHistory:false,			
			car_detail:{},
			rowHistoryCheck:0,
			editItem:null,
			quotationList:[],
			rowHisQoCheck:0
		}
	}	
	
  	componentDidMount() {
  		this._notificationSystem = this.refs.notificationSystem;	
	}

	getNumberFormat(value) {
    	value = (value===''||value===null||value===undefined||isNaN(value)?0:value)
    	let _val = value*1
    	return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  	}

	sortRowIndex(itemlist,key) {
		let {isCheckAll} = this.state
		let checkAll = true
		itemlist = itemlist.map((item,index)=>{
			item.seq = (index+1).toString()
			if (!item.isCheck)
				checkAll = false
			return item
		})
		isCheckAll[key] = checkAll
		this.setState({isCheckAll:isCheckAll})
		return itemlist
	}

	loadData(complete) {
		let {eventKey,isSelect,editItem,rowHisQoCheck,quotationList} = this.state
		let qoNo = eventKey!=="quotation" &&quotationList.length>0?quotationList[rowHisQoCheck].quotation_no:""

		WorkdocStore.loadInvoicedocDetail(this.props.workNo,eventKey,qoNo,(result)=>{
			let summary_itemlist = this.sortRowIndex(result.data.summary_itemlist,'summary_itemlist')
			let summary2_itemlist = this.sortRowIndex(result.data.summary2_itemlist,'summary2_itemlist')
			let work_itemlist = this.sortRowIndex(result.data.work_itemlist,'work_itemlist')
			if(result.data.default_detail_type){
				isSelect = result.data.default_detail_type
			}
			if(editItem){
				result.data.meta.vat_type = editItem.vat_type
			}
			this.setState({
				summary_itemlist:summary_itemlist,
				summary2_itemlist:summary2_itemlist,
				meta:result.data.meta,
				car_detail:result.data.car_detail,
				wage_itemlist:this.sortRowIndex(result.data.wage_itemlist,'wage_itemlist'),
				part_itemlist:this.sortRowIndex(result.data.part_itemlist,'part_itemlist'),
				work_itemlist:work_itemlist,
				work_status:result.data.work_status,
				isSelect:isSelect},()=>{
				if (complete!==undefined)
					complete('OK')
			})
		})
	}
	
	onMenuItemSelect(eventKey) {
		this.props.onMenuItemSelect(()=>{
			if (eventKey=='exportstock' ) {
				this.props.onCreateInvoice(eventKey,{},()=>{
					this.onHide();
				})			
			}else {
				WorkdocStore.loadDocRecord(this.props.workNo,eventKey,(result)=>{
					if (result.data.length>0) {
						this.setState({data:result.data,showHistory:true})
					} else {
						this.loadData((result)=>{
							if (result==='OK') {
								if(eventKey!=="quotation"){
									WorkdocStore.loadDocRecord(this.props.workNo,"quotation",(result)=>{
										
										this.setState({show:true,quotationList:result.data,rowHisQoCheck:0})
										
									})		
								}else{								
									this.setState({show:true})
								}
							}			
						})
					}
				})
			} 
			this.setState({eventKey:eventKey})
		})
	}

	onHide() {
		this.setState({show:false,showHistory:false})
	}

	onCreateInvoice(){
		//Save
		let {isSelect,summary_itemlist,summary2_itemlist,work_itemlist,wage_itemlist,part_itemlist,eventKey,meta,car_detail,work_status,editItem} = this.state
		let itemlist = isSelect==='summary'?summary_itemlist:isSelect==='summary2'?summary2_itemlist:work_itemlist
		let header = Object.assign({work_no:this.props.workNo,customer_name:'',customer_address:'',customer_tax:'',customer_branch:'',amount:'',vat_type:''},meta,{seq_no:''})
		let postData = {iv:'',new_doc:true,header:header,item:itemlist,car_detail:car_detail,work_status:work_status}
		if(editItem){
			postData.new_doc = false
			postData.iv = editItem[eventKey+"_no"];
			postData.header.seq_no = editItem.seq_no
			postData.header.vat_type = editItem.vat_type
			postData.header.invoice_date  = editItem[eventKey+"_date"]
		}
		if(eventKey=="quotation"){
			postData['wage_itemlist'] = wage_itemlist
			postData['part_itemlist'] = part_itemlist
		}
		// GenDocStore.saveDoc(postData,eventKey,(result)=>{
		// 	if(result.status=='OK'){
		// 		if (typeof window.show_invoice_doc!=='undefined'){
		// 			window.show_invoice_doc(result.id);
		// 		}
		// 	}
		// })	
		console.log("postData",postData);		
		this.props.onCreateInvoice(eventKey,postData,()=>{
			this.onHide();
		})	
	}

	onSelect(val) {
		this.setState({isSelect:val})
	}

	onNewClick() {
		let {eventKey} = this.state
		this.setState({editItem:null},()=>{
			this.loadData((result)=>{
				if (result==='OK') {
					if(eventKey!=="quotation"){
						WorkdocStore.loadDocRecord(this.props.workNo,"quotation",(result)=>{
							
							this.setState({show:true,quotationList:result.data,rowHisQoCheck:0})
							
						})		
					}else{					
						this.setState({show:true})
					}
				}			
			})	
		})

	}

	onUpdateDocClick(){
		let {data,eventKey,rowHistoryCheck} = this.state					
		
		this.setState({editItem:data[rowHistoryCheck]},()=>{
			this.loadData((result)=>{
				if (result==='OK') {
					if(eventKey!=="quotation"){
						WorkdocStore.loadDocRecord(this.props.workNo,"quotation",(result)=>{
							
							this.setState({show:true,quotationList:result.data,rowHisQoCheck:0})
							
						})		
					}else{
						this.setState({show:true})
					}
				}			
			})	
		})
		
	}

	checkAll(itemlist,status) {
		itemlist = itemlist.map((item,index)=>{
			item.isCheck = status
			return item
		})
		return itemlist
	}

	onRowCheckAll(status,key) {
		let {summary_itemlist,summary2_itemlist,work_itemlist,wage_itemlist,part_itemlist,isCheckAll} = this.state
		if (key==='summary_itemlist') {
			isCheckAll.summary_itemlist = status
			this.setState({isCheckAll:isCheckAll,summary_itemlist:this.checkAll(summary_itemlist,status)})
		} else if (key==='summary2_itemlist') {
			isCheckAll.summary2_itemlist = status
			this.setState({isCheckAll:isCheckAll,summary2_itemlist:this.checkAll(summary2_itemlist,status)})
		} else if (key==='work_itemlist') {
			isCheckAll.work_itemlist = status
			this.setState({isCheckAll:isCheckAll,work_itemlist:this.checkAll(work_itemlist,status)})
		} else if (key==='wage_itemlist') {
			isCheckAll.wage_itemlist = status
			this.setState({isCheckAll:isCheckAll,wage_itemlist:this.checkAll(wage_itemlist,status)})
		} else if (key==='part_itemlist') {
			isCheckAll.part_itemlist = status
			this.setState({isCheckAll:isCheckAll,part_itemlist:this.checkAll(part_itemlist,status)})
		}
	}

	onRowCheck(index,status,key) {
		let {summary_itemlist,summary2_itemlist,work_itemlist,wage_itemlist,part_itemlist,isCheckAll} = this.state
		if (key==='summary_itemlist') {
			summary_itemlist[index].isCheck = status
			if (status) {
				let checkAll = true
				summary_itemlist.forEach((item,index)=>{
					if (!item.isCheck)
						checkAll = false
				})
				isCheckAll.summary_itemlist = checkAll
				this.setState({isCheckAll:isCheckAll})
			}		
		} else if (key==='summary2_itemlist') {
			summary2_itemlist[index].isCheck = status
			if (status) {
				let checkAll = true
				summary2_itemlist.forEach((item,index)=>{
					if (!item.isCheck)
						checkAll = false
				})
				isCheckAll.summary2_itemlist = checkAll
				this.setState({isCheckAll:isCheckAll})
			}		
		} else if (key==='work_itemlist') {
			work_itemlist[index].isCheck = status
			if (status) {
				let checkAll = true
				work_itemlist.forEach((item,index)=>{
					if (!item.isCheck)
						checkAll = false
				})
				isCheckAll.work_itemlist = checkAll
				this.setState({isCheckAll:isCheckAll})
			}
		} else if (key==='wage_itemlist') {
			wage_itemlist[index].isCheck = status
			if (status) {
				let checkAll = true
				wage_itemlist.forEach((item,index)=>{
					if (!item.isCheck)
						checkAll = false
				})
				isCheckAll.wage_itemlist = checkAll
				this.setState({isCheckAll:isCheckAll})
			}
		} else if (key==='part_itemlist') {
			part_itemlist[index].isCheck = status
			if (status) {
				let checkAll = true
				part_itemlist.forEach((item,index)=>{
					if (!item.isCheck)
						checkAll = false
				})
				isCheckAll.part_itemlist = checkAll
				this.setState({isCheckAll:isCheckAll})
			}
		}	
		console.log('part_itemlist=>',part_itemlist)
		this.setState({summary_itemlist:summary_itemlist,summary2_itemlist:summary2_itemlist,work_itemlist:work_itemlist,wage_itemlist:wage_itemlist,part_itemlist:part_itemlist},()=>{
			if (!status) {
				if (key==='summary_itemlist')
					isCheckAll.summary_itemlist = false
				else if (key==='summary2_itemlist')
					isCheckAll.summary2_itemlist = false
				else if (key==='work_itemlist')
					isCheckAll.work_itemlist = false
				else if (key==='wage_itemlist')
					isCheckAll.wage_itemlist = false
				else if (key==='part_itemlist')
					isCheckAll.part_itemlist = false		
				
				this.setState({isCheckAll:isCheckAll})
			}	
		})	
	}

	renderColDetail(index,key,item) {
		let {can_drag,darg_id} = this.state
		let uniq = key+'-'+item.seq
		let hover = (
			<OverlayTrigger
				key={'right'}
				placement={'right'}
				overlay={
					<Tooltip id={'tooltip-right'}>
						Hold & darg to sort the Items
					</Tooltip>
				}
				>
				<div className='wrap-tool'>
					<div className='card-tool'><FontAwesome name='bars' /></div>
				</div>
			</OverlayTrigger>
		)
		return([
							<td key={0} className='text-center'>
								<Checkbox
									onChange={this.onRowCheck.bind(this,index,!item.isCheck,key)}
									checked={item.isCheck}
									checkboxClass="icheckbox_square-blue"
									increaseArea="20%"
									label=""
								>
                				</Checkbox>
							</td>,
							<td 
								key={1} 
								className='text-center'
								style={{verticalAlign:'middle',width:'50px',minWidth:'50px'}}
								onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}} 
								onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}}
							>
								{can_drag&&darg_id===uniq?hover:index+1}
							</td>,
							<td key={2} className='text-left'>{item.detail}</td>,
							<td key={3} className='text-center'>{item.quantity}</td>,
							<td key={4} className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>,
							<td key={5} className='text-right'>{this.getNumberFormat(item.amount)}</td>
		])
	}

	renderRowData(data,key){
		let {can_drag} = this.state
		if (data.length===0) {
			return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
		}
		return data.map((item,index)=> { 
			return <DNDRowItem 
				key={index} 
				id={key+'-'+item.seq}
				item={item}
				can_drag={can_drag}
				moveRow={this.onMoveRow.bind(this,key)}
				renderColDetail={this.renderColDetail.bind(this,index,key)}
			/>
    	})
	}
	
	onMoveRow(key,id,afterId) {
		let arrId = []
		let arrAfterId = []
		arrId = id.split('-')
		arrAfterId = afterId.split('-')
		if ((arrId.length>0&&arrAfterId.length>0)&&(arrId[0]===arrAfterId[0])) {
			let {summary_itemlist,summary2_itemlist,work_itemlist,wage_itemlist,part_itemlist} = this.state
			let data = []
			if (key==='summary_itemlist')
				data = summary_itemlist
			else if (key==='summary2_itemlist')
				data = summary2_itemlist
			else if (key==='work_itemlist')
				data = work_itemlist
			else if (key==='wage_itemlist')
				data = wage_itemlist
			else if (key==='part_itemlist')
				data = part_itemlist		
							
			var rows = _.clone(data);
			var currentRow = _.filter(rows, function (r) { return key+'-'+r.seq === id; })[0];
			var afterRow = _.filter(rows, function (r) { return key+'-'+r.seq === afterId; })[0];

			var currentRowIndex = rows.indexOf(currentRow);
			var afterRowIndex = rows.indexOf(afterRow);

			// remove the current row
			rows.splice(currentRowIndex, 1);
			// put it after
			rows.splice(afterRowIndex, 0, currentRow);
			data = rows
			if (key==='summary_itemlist')
				this.setState({summary_itemlist:data})
			else if (key==='summary2_itemlist')
				this.setState({summary2_itemlist:data})
			else if (key==='work_itemlist')
				this.setState({work_itemlist:data})
			else if (key==='wage_itemlist')
				this.setState({wage_itemlist:data})
			else if (key==='part_itemlist')
				this.setState({part_itemlist:data})
		}		
	}
	
	onRowClick(item) {
		this.props.onHistoryRowClick(this.state.eventKey,item,()=>{
			this.onHide();
		})
	}

	onVatChange(e) {
		this.setState({meta:Object.assign(this.state.meta,{vat_type:e.value})})
	}

	getTotalBeforeVat(key) {
  		let sum = 0
		let {meta,summary_itemlist,summary2_itemlist,work_itemlist,wage_itemlist,part_itemlist} = this.state
		let {vat_type} = meta
		let data = []
		if (key==='summary_itemlist')
			data = summary_itemlist
		else if (key==='summary2_itemlist')
			data = summary2_itemlist
		else if (key==='work_itemlist')
			data = work_itemlist
		else if (key==='wage_part_itemlist')
			data = wage_itemlist.concat(part_itemlist)
		
		data.forEach((item,index)=>{
			if (item.isCheck)
				sum += (this.getAmountPerRow(item)*1)
		})
		if (vat_type==='VAT_INCLUDE'){
			sum = sum/1.07
		}
  		return sum
	}

	getTotalVat(key) {
		let {meta} = this.state
		let {vat_type} = meta
		let sum = 0
  		if (vat_type==='NON_VAT')
  			sum = 0.00
		else 
			sum = (this.getTotalBeforeVat(key) * 0.07) 
  		return sum
	}
	
	getTotalNet(key) {
  		return (this.getTotalBeforeVat(key)*1) + (this.getTotalVat(key)*1)
	}
	
	getAmountPerRow(item) {
		let amount = 0
		let quantity = this.getValid(item.quantity)
		let price_per_unit = this.getValid(item.price_per_unit)
		amount += (quantity*price_per_unit)
		return amount
	}

	getValid(value) {
		value = (value===''?0:value===null?0:value===undefined?0:isNaN(value)?0:value)
		return value
	}


	onRowHistoryCheck(index){
		this.setState({rowHistoryCheck:index})
	}

	onRowHisQoCheck(index){
		this.setState({rowHisQoCheck:index},()=>{
			this.loadData((result)=>{

			})
		})
	}

	renderWageAndPartTable(){
		let {part_itemlist,wage_itemlist,isCheckAll}  = this.state
		return (
			<div>
				ค่าแรง
				<div className='table-responsive'>
					<table className='table table-hover table-bordered-solid'>
						<thead>
							<tr>
								<th className='text-center' style={{width:'50px'}}>
									<Checkbox
										onChange={this.onRowCheckAll.bind(this,!isCheckAll['wage_itemlist'],'wage_itemlist')}
										checked={isCheckAll['wage_itemlist']}
										checkboxClass="icheckbox_square-blue"
										increaseArea="20%"
										label=""
									>
									</Checkbox>
								</th>
								<th className='text-center' style={{width:'50px'}}>ลำดับ</th>
								<th className='text-center' style={{width:'150px'}}>รายการ</th>
								<th className='text-center' style={{width:'90px'}}>จำนวน</th>
								<th className='text-center' style={{width:'100px'}}>ราคาต่อหน่วย</th>
								<th className='text-center' style={{width:'100px'}}>ยอดรวม</th>
							</tr>
						</thead>
						<tbody>
							{this.renderRowData(wage_itemlist,'wage_itemlist')}
						</tbody>
					</table>
				</div>
				ค่าอะไหล่
				<div className='table-responsive'>
					<table className='table table-hover table-bordered-solid'>
						<thead>
							<tr>
								<th className='text-center' style={{width:'50px'}}>
									<Checkbox
										onChange={this.onRowCheckAll.bind(this,!isCheckAll['part_itemlist'],'part_itemlist')}
										checked={isCheckAll['part_itemlist']}
										checkboxClass="icheckbox_square-blue"
										increaseArea="20%"
										label=""
									>
									</Checkbox>
								</th>
								<th className='text-center' style={{width:'50px'}}>ลำดับ</th>
								<th className='text-center' style={{width:'150px'}}>รายการ</th>
								<th className='text-center' style={{width:'90px'}}>จำนวน</th>
								<th className='text-center' style={{width:'100px'}}>ราคาต่อหน่วย</th>
								<th className='text-center' style={{width:'100px'}}>ยอดรวม</th>
							</tr>
						</thead>
						<tbody>
							{this.renderRowData(part_itemlist,'part_itemlist')}
						</tbody>
					</table>
				</div>
			</div>
					
		)
	}

	renderFromQuotation(){
		let {eventKey} = this.state
		if(eventKey==="quotation"){
			return null
		}
		return (<div>
					<Row>
						<Col md={12} sm={12}>
							<div>ใส่ราคาอนุมัติจากใบเสนอ</div>
						</Col>
					</Row>
					{this.renderHistoryQuotationTable()}
			</div>)
	}

	renderModal() {
		let {show,eventKey,editItem} = this.state
		let {workNo} = this.props
		let {summary_itemlist,summary2_itemlist,work_itemlist,isSelect,isCheckAll} = this.state
		let data = (isSelect==='summary'?summary_itemlist:isSelect==='summary2'?summary2_itemlist:work_itemlist)
		let key = (isSelect==='summary'?'summary_itemlist':isSelect==='summary2'?'summary2_itemlist':'work_itemlist')
		let key_summary = (isSelect==='summary'?'summary_itemlist':isSelect==='summary2'?'summary2_itemlist':isSelect==='detail'?(eventKey==="quotation"?'wage_part_itemlist':'work_itemlist'):"work_itemlist") 
		let docName = eventKey==='quotation'
		?'ใบเสนอราคา'
		:eventKey==='invoice'
		?'ใบแจ้งหนี้'
		:eventKey==='receipt'
		?'ใบเสร็จรับเงิน'
		:eventKey==='taxinvoice'
		?'ใบกำกับภาษี'
		:eventKey==='cashbill'
		?'บิลเงินสด'
		:'';
		let title = "สร้างเอกสาร" + docName+ " จากใบงาน "+ workNo
		if(editItem){
			title = "แก้ไขเอกสาร" + docName+ " เลขที่ "+editItem[eventKey+"_no"]+ " จากใบงาน "+ workNo
		}
		return(
			<div>
				<Modal bsSize="large" show={show} onHide={this.onHide.bind(this)}>
          			<Modal.Header closeButton>
           				<Modal.Title>
							{title}
            			</Modal.Title>
          			</Modal.Header>
		  			<Modal.Body>
						
					  	{this.renderFromQuotation()}
						<Row>
							<Col md={12} sm={12}>
								<div>{this.state.meta.customer_name}</div>
							</Col>
						</Row>
						<Row>
							<Col md={9} sm={9}>
								<Radio
									onChange={this.onSelect.bind(this,'summary')}
									checked={this.state.isSelect==='summary'?true:false}
									radioClass="iradio_square-blue"
									increaseArea="20%"
									label=" สรุปรวม"
									>
								</Radio>
								{' '}
								<Radio
									onChange={this.onSelect.bind(this,'summary2')}
									checked={this.state.isSelect==='summary2'?true:false}
									radioClass="iradio_square-blue"
									increaseArea="20%"
									label=" สรุปรวมแบบ 2"
									>
								</Radio>
								{' '}
								<Radio
									onChange={this.onSelect.bind(this,'detail')}
									checked={this.state.isSelect==='detail'?true:false}
									radioClass="iradio_square-blue"
									increaseArea="20%"
									label=" แสดงรายละเอียด"
								>
								</Radio>
							</Col>
							<Col md={3} sm={3}>
								<div className='text-right'>
									<FormGroup className='text-left'>
										<ControlLabel>คิดภาษีแบบ</ControlLabel>
										<Select
											placeholder='--- เลือก Vat ---'
											options={[{value:'VAT_INCLUDE',label:'Vat ใน'},{value:'VAT_EXCLUDE',label:'Vat นอก'},{value:'NON_VAT',label:'ไม่รวม Vat'}]}
											value={this.state.meta.vat_type}
											onChange={this.onVatChange.bind(this)}
											clearable={false}
										/>
									</FormGroup>
								</div>
							</Col>	
						</Row>
						{(this.state.isSelect==="detail" && eventKey==="quotation")?(this.renderWageAndPartTable()):(
						<div className='table-responsive'>
							<table className='table table-hover table-bordered-solid'>
								<thead>
									<tr>
										<th className='text-center' style={{width:'50px'}}>
											<Checkbox
												onChange={this.onRowCheckAll.bind(this,!isCheckAll[key],key)}
												checked={isCheckAll[key]}
												checkboxClass="icheckbox_square-blue"
												increaseArea="20%"
												label=""
											>
											</Checkbox>
										</th>
										<th className='text-center' style={{width:'50px'}}>ลำดับ</th>
										<th className='text-center' style={{width:'150px'}}>รายการ</th>
										<th className='text-center' style={{width:'90px'}}>จำนวน</th>
										<th className='text-center' style={{width:'100px'}}>ราคาต่อหน่วย</th>
										<th className='text-center' style={{width:'100px'}}>ยอดรวม</th>
									</tr>
								</thead>
								<tbody>
									{this.renderRowData(data,key)}
								</tbody>
							</table>
						</div>)}				
						<div>
							<Row>
								<Col md={7} sm={7}></Col>
								<Col md={5} sm={5}>
									<div>
										<table className='table table-doc-summary'>
											<tbody>
												<tr>
													<td style={{width:'60%'}} className="text-right">ยอดรวมก่อนภาษี</td>
													<td style={{width:'35%'}} className="text-right">{this.getNumberFormat(this.getTotalBeforeVat(key_summary))}</td>
													<td style={{width:'5%'}} className="text-right">บาท</td>
												</tr>
												<tr>
													<td className="br-b text-right">ภาษีมูลค่าเพิ่ม 7%</td>
													<td className="br-b text-right">{this.getNumberFormat(this.getTotalVat(key_summary))}</td>
													<td className="br-b text-right">บาท</td>
												</tr>
												<tr>
													<td className="text-right"><b>ยอดรวมสุทธิ</b></td>
													<td className="text-right">{this.getNumberFormat(this.getTotalNet(key_summary))}</td>
													<td className="text-right">บาท</td>
												</tr>
											</tbody>
										</table>
									</div>
								</Col>
							</Row>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button bsStyle='primary' onClick={this.onCreateInvoice.bind(this)}>
              				<FontAwesome name='file-text' /> สร้างเอกสาร
            			</Button>
            			<Button onClick={this.onHide.bind(this)}>
              				<FontAwesome name='close' /> ยกเลิก
            			</Button>
          			</Modal.Footer>
				</Modal>	
			</div>			
		)
	}

	renderHistoryRowData() {
		let {data,eventKey,rowHistoryCheck} = this.state
		if (data.length===0) {
			return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
		}
		return data.map((item,index)=>{
			return (<tr key={index} >
				<td className='text-center'>
					<Radio
					onChange={this.onRowHistoryCheck.bind(this,index)}
					checked={rowHistoryCheck===index}
					radioClass="iradio_square-blue"
					increaseArea="20%"
					label={' '}
				>
				</Radio>
				</td>
				<td className='text-center' onClick={this.onRowClick.bind(this,item)}>{eventKey==='quotation'?item['quotation_date']:item['invoice_date']}</td>
				<td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item[eventKey+'_no']}</td>
				<td className='text-right' onClick={this.onRowClick.bind(this,item)}>{item.amount}</td>
				<td onClick={this.onRowClick.bind(this,item)}>{item.remark}</td>
			</tr>)
    	})
  }

  renderHistoryTable() {
    return (
				<div className='table-responsive'>
      				<table className="table table-bordered-solid table-hover">
						<thead>
							<tr>              
								<th className='text-center'></th>
								<th className='text-center'>วันที่</th>
								<th className='text-center'>เอกสารเลขที่</th>                                            
								<th className='text-center'>มูลค่า</th> 
								<th className='text-center'>หมายเหตุ</th>
							</tr>
						</thead>
						<tbody>
							{this.renderHistoryRowData()}
						</tbody>
						<tfoot>
							<tr>              
								<th className='text-center'></th>
								<th className='text-center'>วันที่</th>
								<th className='text-center'>เอกสารเลขที่</th>                                            
								<th className='text-center'>มูลค่า</th> 
								<th className='text-center'>หมายเหตุ</th>
							</tr>
						</tfoot>
					</table>
				</div>		
    )
  }

		renderHistoryQuotationRowData() {
			let {quotationList,rowHisQoCheck} = this.state
			if (quotationList.length===0) {
				return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
			}
			return quotationList.map((item,index)=>{
				return (<tr key={index} >
					<td className='text-center'>
						<Radio
						onChange={this.onRowHisQoCheck.bind(this,index)}
						checked={rowHisQoCheck===index}
						radioClass="iradio_square-blue"
						increaseArea="20%"
						label={' '}
					>
					</Radio>
					</td>
					<td className='text-center' >{item['quotation_date']}</td>
					<td className='text-center' >{item['quotation_no']}</td>
					<td className='text-right' >{item.amount}</td>
					<td className='text-right' >{item.approved_wage}</td>
					<td className='text-right' >{item.approved_part}</td>
					<td className='text-right' >{item.approved_amount}</td>
					<td onClick={this.onRowClick.bind(this,item)}>{item.remark}</td>
				</tr>)
			})
		}

		renderHistoryQuotationTable() {
		return (
					<div className='table-responsive'>
						<table className="table table-bordered-solid table-hover">
							<thead>
								<tr>              
									<th className='text-center'></th>
									<th className='text-center'>วันที่</th>
									<th className='text-center'>เอกสารเลขที่</th>                                            
									<th className='text-center'>ราคาเสนอ</th> 
									<th className='text-center'>ราคาอนุมัติค่าแรง</th>
									<th className='text-center'>ราคาอนุมัติค่าอะไหล่</th>
									<th className='text-center'>ราคาอนุมัติรวม</th> 
									<th className='text-center'>หมายเหตุ</th>
								</tr>
							</thead>
							<tbody>
								{this.renderHistoryQuotationRowData()}
							</tbody>
							<tfoot>
								<tr>              
									<th className='text-center'></th>
									<th className='text-center'>วันที่</th>
									<th className='text-center'>เอกสารเลขที่</th>                                            
									<th className='text-center'>ราคาเสนอ</th> 
									<th className='text-center'>ราคาอนุมัติค่าแรง</th>
									<th className='text-center'>ราคาอนุมัติค่าอะไหล่</th>
									<th className='text-center'>ราคาอนุมัติรวม</th> 
									<th className='text-center'>หมายเหตุ</th>
								</tr>
							</tfoot>
						</table>
					</div>		
		)
		}

	renderHistoryModal() {
		let {showHistory} = this.state
		return(
			<Modal show={showHistory} enforceFocus={false} onHide={()=>{this.setState({showHistory:false})}} dialogClassName="smallwidth-dialog">
				<Modal.Header closeButton>
					<Modal.Title>พบรายการเอกสารที่เคยสร้าง เปิดดูเอกสารด้วยการคลิ๊กบนแถว หรือสร้างเอกสารใหม่</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{this.renderHistoryTable()}
				</Modal.Body>
				<Modal.Footer>
					<ButtonToolbar className='pull-right'>
						<Button bsStyle={'success'} onClick={this.onUpdateDocClick.bind(this)}><FontAwesome name='refresh'/>&nbsp;อับเดทเอกสารเดิม</Button>
						<Button bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name='file-text-o'/>&nbsp;สร้างเอกสารใหม่</Button>
						<Button onClick={()=>{this.setState({showHistory:false})}}><FontAwesome name='close'/>&nbsp;ปิด</Button>
					</ButtonToolbar>
				</Modal.Footer>
			</Modal>
		)
	}

  render() {
		let title = (<span><i className="fa fa-edit"></i>&nbsp;สร้างเอกสาร</span>)
	  return(
			<div>
				<DropdownButton id='workdoc-invoice-menu' bsStyle={'primary'} title={title} onSelect={this.onMenuItemSelect.bind(this)}>          
          			<MenuItem eventKey="quotation"><FontAwesome name='file-text-o' className='text-green'/>ใบเสนอราคา</MenuItem>
					<MenuItem divider />
          			<MenuItem eventKey="invoice"><FontAwesome name='file-text-o' className='text-green'/>ใบแจ้งหนี้</MenuItem>   
					<MenuItem eventKey="receipt"><FontAwesome name='file-text-o' className='text-green'/>ใบเสร็จรับเงิน</MenuItem>       
					<MenuItem eventKey="taxinvoice"><FontAwesome name='file-text-o' className='text-green'/>ใบกำกับภาษี</MenuItem>
					<MenuItem eventKey="cashbill"><FontAwesome name='file-text-o' className='text-green'/>บิลเงินสด</MenuItem>
					<MenuItem divider />          
					<MenuItem eventKey="exportstock"><FontAwesome name='file-text-o' className='text-green'/>ใบเบิกคลังสินค้า</MenuItem>
				</DropdownButton>
				{this.renderModal()}
				<NotificationSystem ref="notificationSystem" />
				{this.renderHistoryModal()}
			</div>
  	)
  }
}

WorkDocInvoiceMenu.defaultProps = {
	workNo:'',
	onCreateInvoice:(eventKey,postData,callback)=>{callback()},
	onMenuItemSelect:(callback)=>{callback()},
	onHistoryRowClick:(eventKey,item,callback)=>{callback()}
}

export default WorkDocInvoiceMenu = connect(
  (state) => ({messages: state.message.view.workdoc.WorkDocInvoiceMenu}),null,null,{withRef:true}
)(WorkDocInvoiceMenu);


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocInvoiceMenu.js